<template>
  <item-wrapper>
    <template slot="title">
      <title-wrapper :title="`近${period}天工程师排名`"></title-wrapper>
    </template>
    <template slot="content">
      <engineerRank />
    </template>
  </item-wrapper>
</template>

<script>
import itemWrapper from '../itemWrapper.vue';
import titleWrapper from '../titleWrapper.vue';
import engineerRank from './engineerRank.vue';

export default {
  name: 'workOrderStatus',
  components: {
    itemWrapper,
    titleWrapper,
    engineerRank,
  },
  inject: ['periodFn'],
  computed: {
    period () {
      return this.periodFn();
    },
  },
};
</script>
